import { readAmplitudeProps, trackAmplitudeEvents } from "../../utils/events/amplitude";

const wrappers = document.querySelectorAll(".js-follow-button-wrapper");

Array.from(wrappers).forEach((wrapper) => {
  wrapper.addEventListener("click", (e) => {
    const child = e.currentTarget.children[0];

    if (child.classList.contains("js-follow-button")) {
      const eventName = e.target.dataset.amplitudeEventName;
      const { eventProperties } = readAmplitudeProps(wrapper.dataset.amplitudeProps);

      trackAmplitudeEvents(eventName, eventProperties);
    }
  });
});
